import Link from "next/link";
import { Intermedes } from "../icons-legacy/Intermedes";

type Props = {
  frontUrl: string;
};
// Same footer as apps/intermedes/components/footer/Legals, with absolute links for apps on another host
export const LegalsBar = ({ frontUrl }: Props) => {
  return (
    <div className="bg-black text-tx-3 text-xs md:text-base">
      <div className="container flex items-center content-center flex-wrap h-14 md:h-[68px]">
        <div className="brightness-0 invert w-[156px] hidden md:block">
          <Intermedes className="w-full" />
        </div>
        <div className="hidden md:block grow" />
        <p className="basis-full md:basis-auto">{`© Copyright Intermèdes ${new Date().getFullYear()}`}</p>
        <p className="px-1 hidden md:block">{" | "}</p>
        <Link
          prefetch={false}
          href={`${frontUrl}/entreprise/donnees-et-garanties/`}
          className="underline hover:text-pr-1"
        >
          Mentions légales
        </Link>
        <p className="px-1">{" | "}</p>
        <Link
          prefetch={false}
          href={`${frontUrl}/entreprise/credits-photos-voyages/`}
          className="underline hover:text-pr-1"
        >
          Crédits
        </Link>
        <p className="px-1">{" | "}</p>
        <Link prefetch={false} href={`${frontUrl}/plan-du-site/`} className="underline hover:text-pr-1">
          Plan du site
        </Link>
      </div>
    </div>
  );
};
